<div [formGroup]="form" class="row">
  <div class="col-12 col-md-6 mb-2">
    <label for="vehicleFormYear" class="form-label noselect">Year</label>
    <select id="vehicleFormYear" class="form-select" formControlName="year">
      <option value="" disabled>Select year…</option>
      <option *ngFor="let year of years" [value]="year">{{ year }}</option>
    </select>
  </div>

  <div class="col-12 col-md-6 mb-2">
    <ng-container *ngIf="makesState !== 'unavailable'; else makeFreeText">
      <label for="vehicleFormMake" class="form-label noselect">Make</label>
      <select id="vehicleFormMake" class="form-select" formControlName="make">
        <option value="" disabled>{{ makesState === 'loading' ? 'Loading makes…' : 'Select make…' }}</option>
        <option *ngFor="let make of makes" [value]="make">{{ make }}</option>
        <option [value]="OTHER">Other…</option>
      </select>
      <app-input *ngIf="isMakeOther" [form]="form" formGroupName="makeOther" placeHolder="Enter make"></app-input>
    </ng-container>
    <ng-template #makeFreeText>
      <label class="form-label noselect">Make</label>
      <app-input [form]="form" formGroupName="make" placeHolder="Make"></app-input>
    </ng-template>
  </div>

  <div class="col-12 col-md-6 mb-2">
    <label *ngIf="makesState !== 'unavailable'" for="vehicleFormModel" class="form-label noselect">Model</label>
    <label *ngIf="makesState === 'unavailable'" class="form-label noselect">Model</label>

    <!-- Full degradation: vPIC unreachable, plain text input bound to the model control -->
    <app-input *ngIf="makesState === 'unavailable'" [form]="form" formGroupName="model" placeHolder="Model"></app-input>

    <!-- Unlisted make or failed model lookup: free text -->
    <app-input *ngIf="makesState !== 'unavailable' && isMakeOther" [form]="form" formGroupName="modelOther" placeHolder="Enter model"></app-input>
    <app-input *ngIf="makesState !== 'unavailable' && !isMakeOther && modelsState === 'unavailable'" [form]="form" formGroupName="model" placeHolder="Model"></app-input>

    <!-- Normal path: model select for the chosen make/year -->
    <ng-container *ngIf="makesState !== 'unavailable' && !isMakeOther && modelsState !== 'unavailable'">
      <select id="vehicleFormModel" class="form-select" formControlName="model">
        <option value="" disabled>
          {{ modelsState === 'loading' ? 'Loading models…' : (modelsState === 'idle' ? 'Select year and make first' : 'Select model…') }}
        </option>
        <option *ngFor="let model of models" [value]="model">{{ model }}</option>
        <option *ngIf="modelsState === 'ready'" [value]="OTHER">Other…</option>
      </select>
      <app-input *ngIf="isModelOther" [form]="form" formGroupName="modelOther" placeHolder="Enter model"></app-input>
    </ng-container>
  </div>

  <div class="col-12 col-md-6 mb-2 align-self-end">
    <app-input [form]="form" formGroupName="vin" placeHolder="VIN (Optional)"
               suffixIcon="fa-camera" suffixLabel="Scan the VIN from a photo"
               [suffixBusy]="scanning === 'vin'"
               (suffixClick)="vinCamera.click()"></app-input>
    <div *ngIf="scanning === 'vin'" class="scan-status">Reading photo…</div>
  </div>

  <!-- Plate and state share a line: 8/4 on phones, separate half-width
       columns on md+ so the full "(Optional)" label has room. -->
  <div class="col-8 col-md-6 mb-2 align-self-end">
    <app-input [form]="form" formGroupName="licensePlate" label="Plate (Optional)" placeHolder="Plate"
               suffixIcon="fa-camera" suffixLabel="Scan the plate number from a photo"
               [suffixBusy]="scanning === 'plate'"
               (suffixClick)="plateCamera.click()"></app-input>
    <div *ngIf="scanning === 'plate'" class="scan-status">Reading photo…</div>
  </div>
  <div class="col-4 col-md-6 mb-2 align-self-end">
    <label for="vehicleFormPlateState" class="form-label noselect">State</label>
    <select id="vehicleFormPlateState" class="form-select" formControlName="plateState">
      <option value=""></option>
      <option *ngFor="let state of states" [value]="state">{{ state }}</option>
    </select>
  </div>
</div>

<!-- capture="environment" opens the rear camera on a phone; on desktop the
     attribute is ignored and this is an ordinary file picker. -->
<input #vinCamera type="file" accept="image/*" capture="environment" hidden
       (change)="onScanFile($event, 'vin')">
<input #plateCamera type="file" accept="image/*" capture="environment" hidden
       (change)="onScanFile($event, 'plate')">
